import { useRef } from 'react';
import { useDebounce } from 'react-use';

export const useDelayChanger = <T>(
  // eslint-disable-next-line @typescript-eslint/ban-types
  callback: Function | undefined,
  params: T[],
  delay = 500,
) => {
  const isInitialComponent = useRef(true);

  useDebounce(
    () => {
      if (isInitialComponent.current) {
        isInitialComponent.current = false;
      } else {
        callback?.(...params);
      }
    },
    delay,
    params,
  );
};
